import { render, staticRenderFns } from "./FilterTransaction.vue?vue&type=template&id=2fa449cd&"
import script from "./FilterTransaction.vue?vue&type=script&lang=js&"
export * from "./FilterTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports